import { loadBasic } from "tsparticles-basic";
import { loadEmittersPlugin } from "tsparticles-plugin-emitters";
import { options } from "./options";
export async function loadBubblesPreset(engine, refresh = true) {
    await loadBasic(engine, false);
    await loadEmittersPlugin(engine, false);
    await engine.addPreset("bubbles", options, refresh);
}
